var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"ui-editor",staticClass:"ui-editor",attrs:{"frameborder":"0","rel":"noreferrer","referrerpolicy":"no-referrer","placeholder":"placeholder"}})}
var staticRenderFns = []

export { render, staticRenderFns }